import Head from 'next/head'

import Layout from '../components/Layout'
import ColoredLink from '../components/ColoredLink'

function PhoneIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-5 w-5"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      viewBox="0 0 24 24"
    >
      <path
        d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 0 0 2.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 0 1-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 0 0-1.091-.852H4.5A2.25 2.25 0 0 0 2.25 4.5v2.25Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function EmailIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-5 w-5"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      viewBox="0 0 24 24"
    >
      <path
        d="M21.75 6.75v10.5a2.25 2.25 0 0 1-2.25 2.25h-15a2.25 2.25 0 0 1-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0 0 19.5 4.5h-15a2.25 2.25 0 0 0-2.25 2.25m19.5 0v.243a2.25 2.25 0 0 1-1.07 1.916l-7.5 4.615a2.25 2.25 0 0 1-2.36 0L3.32 8.91a2.25 2.25 0 0 1-1.07-1.916V6.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

function LocationIcon() {
  return (
    <svg
      aria-hidden="true"
      className="h-5 w-5"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      viewBox="0 0 24 24"
    >
      <path
        d="M15 10.5a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1 1 15 0Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default function Contact(): JSX.Element {
  return (
    <Layout>
      <Head>
        <title>Robert Karasov - Minneapolis Mohel | Contact</title>
      </Head>

      <h1 className="mb-3 font-serif text-4xl text-ink sm:text-3xl">Contact</h1>
      <p className="mb-10 leading-relaxed text-ink-muted">
        Please don&rsquo;t hesitate to reach out with any questions. Bob is
        happy to speak with you before you make any decisions.
      </p>

      <div className="grid grid-cols-3 gap-5 md:grid-cols-1">
        <div className="rounded-xl border border-hairline bg-surface p-6 shadow-card">
          <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-petrol/10 text-petrol">
            <PhoneIcon />
          </div>
          <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-ink-muted">
            Cell
          </p>
          <a
            className="font-serif text-lg text-ink transition hover:text-petrol"
            href="tel:+19528385042"
          >
            952-838-5042
          </a>
        </div>

        <div className="rounded-xl border border-hairline bg-surface p-6 shadow-card">
          <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-petrol/10 text-petrol">
            <EmailIcon />
          </div>
          <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-ink-muted">
            Email
          </p>
          <div className="break-all">
            <ColoredLink
              href="mailto:robertkarasov@gmail.com?subject=Bris"
              target="_blank"
            >
              robertkarasov@gmail.com
            </ColoredLink>
          </div>
        </div>

        <div className="rounded-xl border border-hairline bg-surface p-6 shadow-card">
          <div className="mb-4 flex h-10 w-10 items-center justify-center rounded-lg bg-petrol/10 text-petrol">
            <LocationIcon />
          </div>
          <p className="mb-1 text-xs font-semibold uppercase tracking-widest text-ink-muted">
            Address
          </p>
          <address className="font-serif text-lg not-italic leading-snug text-ink">
            4101 Sunset Blvd
            <br />
            St. Louis Park, MN 55416
          </address>
        </div>
      </div>

      <div className="mt-10 rounded-xl border border-gold/30 bg-gold/5 px-7 py-6">
        <p className="font-serif text-lg text-ink">Bob Karasov, M.D.</p>
        <p className="mt-1 leading-relaxed text-ink-muted">
          Board-certified pediatrician and mohel serving the Twin Cities and
          surrounding communities. Available to travel for families throughout
          Minnesota and beyond.
        </p>
      </div>
    </Layout>
  )
}
